import { SET_USER_DETAILS } from "../action";

function getUserDetailsFromOkta(existingUserDetails) {
  return (dispatch) => {
    let okta_token = localStorage.getItem("okta-token-storage");
    if (okta_token) {
      okta_token = JSON.parse(okta_token);
      if (okta_token.idToken) {
        const {
          email,
          userID,
          country,
          name,
          oktaUserType,
          associatedParentCode,
        } = okta_token.idToken.claims;
        const userId = userID;
        if (!existingUserDetails || existingUserDetails?.userId !== userId) {
          const countryCode = country;
          dispatch({
            type: SET_USER_DETAILS,
            payload: {
              email,
              userId,
              countryCode,
              name,
              oktaUserType,
              associatedParentCode,
            },
          });
        }
      }
    }
  };
}

export default getUserDetailsFromOkta;
